import { render, staticRenderFns } from "./SuccessSubmitForm5.vue?vue&type=template&id=63cf8490&scoped=true"
import script from "./SuccessSubmitForm5.vue?vue&type=script&lang=ts"
export * from "./SuccessSubmitForm5.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63cf8490",
  null
  
)

export default component.exports